const listeners = new Set();
let suppressionCount = 0;

const notify = () => {
  listeners.forEach((listener) => {
    try {
      listener(suppressionCount > 0);
    } catch (_error) {
      // Ignore listener errors so banner state stays recoverable.
    }
  });
};

export const subscribeInitialImportBannerSuppression = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const isInitialImportBannerSuppressed = () => suppressionCount > 0;

export const pushInitialImportBannerSuppression = () => {
  suppressionCount += 1;
  notify();
};

export const popInitialImportBannerSuppression = () => {
  suppressionCount = Math.max(0, suppressionCount - 1);
  notify();
};

export const resetInitialImportBannerSuppressionForTests = () => {
  suppressionCount = 0;
  notify();
};
